import { Language } from "@/contexts/LanguageContext";
import { formatNumber } from "@/lib/utils";

// Format CO2e credits with improved formatting
const formatCO2eCredits = (
  amount: number,
  t: (key: string) => string,
  language: Language,
) => {
  if (amount >= 1000) {
    const tons = amount / 1000;

    return `${formatNumber(tons, language, 4)} ${t("units.co2e.tons")}`;
  }
  return `${formatNumber(amount, language)} ${t("units.co2e.kilograms")}`;
};

export default formatCO2eCredits;
